module.exports = __webpack_public_path__ + "img/close-circle.f332a74a.png";